<template>
  <v-dialog width="800px"
            :value="value"
            @input="toggleModal()"
            persistent
            scrollable>
    <v-card class="kbLight">
      <v-toolbar class="kbPink" dark flat>
        <div class="text-h6">{{ $t('general.addListToSequence') }}</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleModal()">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text v-if="loadingComponent">
        <LoadingComponent height="400px"
                          :message="$t('general.loading')" />
      </v-card-text>

      <v-card-text v-else-if="!loadingComponent && !selectedListId && value">
        <NotFound height="400px" :message="$t('general.listNotFound')" />
      </v-card-text>

      <v-card-text v-else>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" class="pb-0 pt-6">
              <span class="kbDarkBlueText--text d-block text-subtitle-1 mb-2">
                {{ $t('general.selectASequence') }}
              </span>
              <v-autocomplete background-color="kbWhite"
                              color="kbDarkBlueText"
                              :items="sequences"
                              item-text="name"
                              item-value="id"
                              :label="$t('general.selectASequence')"
                              :rules="[rules.required]"
                              solo
                              v-model="sequenceId" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red"
               class="mr-2"
               outlined
               @click="toggleModal()">
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn color="kbPink"
               dark
               :loading="loadingListToSequence"
               @click="submit()">
          {{ $t('general.add') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
import LoadingComponent from '@/components/ui/LoadingComponent'
import NotFound from '@/components/ui/NotFound'
export default {
  components: { LoadingComponent, NotFound },
  computed: {
    ...mapState({
      sequences: state => state.sequences.sequences
    })
  },
  created () {
    this.getSequences()
  },
  data () {
    return {
      loadingListToSequence: false,
      loadingComponent: false,
      rules,
      sequenceId: ''
    }
  },
  methods: {
    clearSelectedList () {
      this.$refs.form.reset()
      this.$emit('clearSelectedList')
    },
    async getSequences () {
      try {
        this.loadingComponent = true
        await this.$store.dispatch('getSequences', { appId: this.$store.getters.appUuid })
        this.loadingComponent = false
      } catch (e) {
        this.loadingComponent = false
        notifications.error(e)
        this.toggleModal()
      }
    },
    async submit () {
      if (!this.$refs.form.validate()) return
      try {
        this.loadingListToSequence = true
        await this.$store.dispatch('addListToSequence', {
          appId: this.$store.getters.appUuid,
          data: { listId: this.selectedListId, sequenceId: this.sequenceId }
        })
        this.loadingListToSequence = false
        notifications.success(this.$t('general.listSuccessfullyAddedToSequence'))
        this.toggleModal()
      } catch (e) {
        this.loadingListToSequence = false
        notifications.error(e)
      }
    },
    toggleModal () {
      this.clearSelectedList()
      this.$emit('input', false)
    }
  },
  props: {
    selectedListId: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>
